<template>
  <footer>
    <p>This website is built with <a href="https://vuejs.org/" target="_blank">Vue.js</a>, and hosted on <a href="https://www.netlify.com/" target="_blank">Netlify</a>.</p>
  </footer>
</template>

<script>
  export default {
    name: 'footer'
  }
</script>

<style lang="scss" scoped>
  footer {
    width: 100%;
    max-width: 1140px;
    margin: 0 auto;
    padding: 100px 0;
  }

  p {
    margin: 0;    
    font-size: 14px;
    color: #969696;
    line-height: 12px;
  }

  a {
    display: inline-block;
    color: #969696;
    font-weight: 500;
    cursor: pointer;
    border-bottom: 1px solid rgba(200, 200, 200, 0);
    transition: border-bottom 0.1s linear;

    &:hover {
      border-bottom: 1px solid rgba(200, 200, 200, 1);
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue